import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'

const PrayerTimeNew = ({
  bgColor1 = '#0341F0',
  bgColor2 = '#266EF0',
  bgColor3 = '#F9AF2E',
  fontColor = 'white',
}) => {
  const [prayerInfo, setPrayerInfo] = useState({})
  const islamicMonths = [
    'MUHARRAM',
    'SAFAR',
    'RABIULAWAL',
    'RABIULAKHIR',
    'JAMADIULAWAL',
    'JAMADILAKHIR',
    'RAJAB',
    'SYAABAN',
    'RAMADHAN',
    'SYAWAL',
    'ZULKAEDAH',
    'ZULHIJJAH',
  ]

  const fetchPrayerData = async () => {
    const dayOfMonth = moment().date()

    fetch(`https://api.waktusolat.app/solat/WLY01/${dayOfMonth}`)
      .then((blob) => blob.json())
      .then((data) => {
        console.log(data)
        if (!isEmpty(data?.prayerTime)) {
          let tempObj = {}

          let islamicMonthIndex = data.prayerTime.hijri.split('-')[1]
          tempObj['monthName'] = islamicMonths[parseInt(islamicMonthIndex) - 1]
          tempObj['islamicYear'] = data.prayerTime.hijri.split('-')[0]
          tempObj['islamicDate'] = data.prayerTime.hijri.split('-')[2]

          setPrayerInfo({ ...tempObj, ...data.prayerTime })
        }
      })
      .catch((e) => {
        console.log(e)
        return e
      })
  }

  useEffect(() => {
    fetchPrayerData()
  }, [])
  return (
    <div
      style={{
        color: fontColor,
        background: bgColor1,
      }}
      className="w-full flex justify-center items-center h-[23px] relative xl:-z-10"
    >
      <div className="prayer-time-scroll-text h-full w-full">
        <div className="flex xl:justify-between items-center text-xs xl:text-[13px] 2xl:text-[15px] w-full h-full">
          <div
            style={{ background: bgColor1 }}
            className="h-full flex justify-center items-center xl:w-[22.76%] px-2 xl:px-0"
          >
            <p className="">WAKTU SOLAT KUALA LUMPUR. PUTRAJAYA</p>
          </div>
          <div
            style={{
              background: `linear-gradient(to bottom right, ${bgColor1} 50%, ${bgColor2} 50%)`,
            }}
            className="aspect-square h-full"
          />
          <div
            style={{ background: bgColor2 }}
            className="flex items-center justify-center xl:w-[21.669%] h-full  px-2 xl:px-0"
          >
            <p className="">{moment().format('DD MMM YYYY')}</p>
            <p className="mx-2">|</p>
            <p className="">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : `${prayerInfo.islamicDate} ${prayerInfo.monthName} ${prayerInfo.islamicYear}H`}
            </p>
          </div>
          <div
            style={{
              background: `linear-gradient(to bottom right, ${bgColor2} 50%, ${bgColor3} 50%)`,
            }}
            className="aspect-square h-full "
          />
          <div
            style={{ background: bgColor3 }}
            className="h-full w-fu xl:w-[54.099%] flex justify-center items-center  px-2 xl:px-0"
          >
            <div className="flex items-center">
              <p className="font-bold">IMSAK</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.fajr}`)
                      .subtract(10, 'minutes')
                      .format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">SUBUH</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.fajr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ZOHOR</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.dhuhr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ASAR</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.asr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">MAGHRIB</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.maghrib}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ISYAK</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.isha}`).format('hh:mm A')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="prayer-time-scroll-text2 h-full w-full absolute top-0 block xl:hidden">
        <div className="flex xl:justify-between items-center text-xs xl:text-[13px] 2xl:text-[15px] w-full h-full">
          <div
            style={{ background: bgColor1 }}
            className="h-full flex justify-center items-center xl:w-[22.76%] px-2 xl:px-0"
          >
            <p className="">WAKTU SOLAT KUALA LUMPUR. PUTRAJAYA</p>
          </div>
          <div
            style={{
              background: `linear-gradient(to bottom right, ${bgColor1} 50%, ${bgColor2} 50%)`,
            }}
            className="aspect-square h-full"
          />
          <div
            style={{ background: bgColor2 }}
            className="flex items-center justify-center xl:w-[21.669%] h-full  px-2 xl:px-0"
          >
            <p className="">{moment().format('DD MMM YYYY')}</p>
            <p className="mx-2">|</p>
            <p className="">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : `${prayerInfo.islamicDate} ${prayerInfo.monthName} ${prayerInfo.islamicYear}H`}
            </p>
          </div>
          <div
            style={{
              background: `linear-gradient(to bottom right, ${bgColor2} 50%, ${bgColor3} 50%)`,
            }}
            className="aspect-square h-full "
          />
          <div
            style={{ background: bgColor3 }}
            className="h-full w-fu xl:w-[54.099%] flex justify-center items-center  px-2 xl:px-0"
          >
            <div className="flex items-center">
              <p className="font-bold">IMSAK</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.fajr}`)
                      .subtract(10, 'minutes')
                      .format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">SUBUH</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.fajr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ZOHOR</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.dhuhr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ASAR</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.asr}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">MAGHRIB</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.maghrib}`).format('hh:mm A')}
              </p>
              <p className="mx-2">|</p>
            </div>
            <div className="flex items-center">
              <p className="font-bold">ISYAK</p>
              <p className="pl-1">
                {isEmpty(prayerInfo)
                  ? 'Loading...'
                  : moment(`${prayerInfo.date} ${prayerInfo.isha}`).format('hh:mm A')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrayerTimeNew
